export default __webpack_public_path__ + "static/media/9_of_spades.dcce4a16.png";